export class Note {
    id: string;
    noteBookId: string;
    name: string;
    content: string;
    search_name?: string;
}
